module.exports = __webpack_public_path__ + "static/media/05.19ba9b31.png";